import { useEffect } from 'react'

import { OneEmptyState } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'
import { trackViewTicketingNotConfigured } from 'modules/ticketing/lib/tracking'

export const NotConfiguredEmptyState = () => {
  useEffect(() => {
    trackViewTicketingNotConfigured()
  }, [])

  return (
    <OneEmptyState
      title={i18n.t('ticketing.onboarding.not_configured_title')}
      description={i18n.t('ticketing.onboarding.not_configured_description')}
    />
  )
}
